export default __webpack_public_path__ + "static/media/qr_code_3.6fc246c7.png";